import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { getModalSelector } from '@store/modals';
import { AdminUsersService, ModalsService, PopupsService } from '@services';
import { longTextReplacer } from '@utils';
import { ApiResponse, ErrorsEnum, Modals, Popups } from '@enums';
import { TableComponent } from '@components';
import { Button, Icon, Modal, TextField, Tooltip } from '@elements';
import { colors, pxToRem } from '@themes';
import { StyledButtonIcon } from './add-users-with-file.styles';
import closeCircle from '@images/close-circle.svg';
import close from '@images/delete.svg';
import edit from '@images/edit.svg';
import save from '@images/save.svg';
import upload from '@images/uploadFile.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Add users with file modal component.
 *
 * @author Ihar Kazlouski
 * @function AddUsersWithFileComponent
 * @category Modals
 * @return {FC} add users with file modal component.
 */
var AddUsersWithFileComponent = function AddUsersWithFileComponent() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var modal = useSelector(getModalSelector(Modals.AddUsersWithFile));

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var modalData = modal === null || modal === void 0 ? void 0 : modal.data;

  var _useState3 = useState(modalData.fileName),
      _useState4 = _slicedToArray(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      tableData = _useState6[0],
      setTableData = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];
  /**
   * Get uploaded users call
   *
   * @author Ihar Kazlouski
   * @param FormData} file file.
   * @return {void}
   */


  var handleGetUsers = function handleGetUsers(file, fileName) {
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resp, users, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return AdminUsersService.apiUploadFilePost({
                id: (modalData === null || modalData === void 0 ? void 0 : modalData.userId) || '',
                body: {
                  file: file
                }
              });

            case 4:
              resp = _context.sent;

              if (resp.data) {
                users = resp.data;

                if (users.find(function (user) {
                  return user.error_text.length !== 0;
                })) {
                  void PopupsService.open(Popups.Default, {
                    header: t('components.popups.errorsDetected'),
                    body: t('components.popups.error.resolvingError'),
                    acceptButton: t('components.popups.ok'),
                    width: 270
                  })["catch"](function () {// ToDo: error handling
                  });
                }

                if (fileName) {
                  setFileName(fileName);
                }

                setTableData(users);
              }

              setLoading(false);
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setLoading(false);
              error = _context.t0;
              void PopupsService.open(Popups.Default, {
                header: error.errorCode === ErrorsEnum.WrongFileStructure ? t('components.popups.fileError') : t('components.popups.uploadError'),
                body: error.errorCode === ErrorsEnum.WrongFileStructure ? t('components.popups.wrongFileStructure') : t('components.popups.uploadFail'),
                acceptButton: t('components.popups.ok'),
                width: 270
              })["catch"](function () {// ToDo: error handling
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }))();
  };

  useEffect(function () {
    handleGetUsers(modalData.formData);
  }, []);
  /**
   * Save changed row.
   *
   * @author Ihar Kazlouski
   * @return {void}
   */

  var handleSaveRow =
  /*#__PURE__*/
  // eslint-disable-next-line @typescript-eslint/require-await
  function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var exitEditingMode, row, values, regex, tableValues;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              exitEditingMode = _ref2.exitEditingMode, row = _ref2.row, values = _ref2.values;
              regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
              tableValues = values;

              if (tableData) {
                tableData[row.index] = {
                  first_name: tableValues.first_name.replace(regex, ''),
                  last_name: tableValues.last_name.replace(regex, ''),
                  phone: tableValues.phone.replace(regex, ''),
                  error_text: tableValues.error_text
                };
              } // // send/receive api updates here


              setTableData(_toConsumableArray(tableData));
              exitEditingMode();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSaveRow(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var columns = useMemo(function () {
    return [{
      accessorKey: 'last_name',
      header: 'Last Name',
      Cell: function Cell(_ref4) {
        var renderedCellValue = _ref4.renderedCellValue;
        var value = renderedCellValue;
        return /*#__PURE__*/_jsx(Tooltip, {
          title: (value === null || value === void 0 ? void 0 : value.length) > 15 ? value : '',
          placement: "bottom-start",
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "comet",
            fontWeight: "500",
            children: longTextReplacer(value, 15)
          })
        });
      }
    }, {
      accessorKey: 'first_name',
      header: 'First Name',
      Cell: function Cell(_ref5) {
        var renderedCellValue = _ref5.renderedCellValue;
        var value = renderedCellValue;
        return /*#__PURE__*/_jsx(Tooltip, {
          title: (value === null || value === void 0 ? void 0 : value.length) > 15 ? value : '',
          placement: "bottom-start",
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "comet",
            fontWeight: "500",
            children: longTextReplacer(value, 15)
          })
        });
      }
    }, {
      accessorKey: 'phone',
      header: 'Phone Number',
      enableSorting: false
    }, {
      accessorKey: 'error_text',
      header: 'Errors',
      enableEditing: false,
      Cell: function Cell(_ref6) {
        var renderedCellValue = _ref6.renderedCellValue;
        return /*#__PURE__*/_jsx(_Fragment, {
          children: renderedCellValue !== null && renderedCellValue !== void 0 && renderedCellValue.length ? /*#__PURE__*/_jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            children: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.map(function (cell) {
              return /*#__PURE__*/_jsx(Typography, {
                color: "comet",
                variant: "body1",
                display: "block",
                fontWeight: "500",
                children: cell
              }, cell);
            })
          }) : '-'
        });
      }
    }];
  }, []);
  /**
   * Replace csv file.
   *
   * @author Ihar Kazlouski
   * @param {ChangeEvent<HTMLInputElement>} event event.
   * @return {void}
   */

  var handleReplace = function handleReplace(event) {
    var _event$target$files, _event$target$files$, _event$target$files2, _event$target$files2$;

    var fileType = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : (_event$target$files$ = _event$target$files[0]) === null || _event$target$files$ === void 0 ? void 0 : _event$target$files$.type;
    var fileName = (_event$target$files2 = event.target.files) === null || _event$target$files2 === void 0 ? void 0 : (_event$target$files2$ = _event$target$files2[0]) === null || _event$target$files2$ === void 0 ? void 0 : _event$target$files2$.name;

    if (fileType === 'text/csv' || fileType === 'application/vnd.ms-excel') {
      var _event$target$files3;

      var reader = new FileReader();
      reader.readAsBinaryString((_event$target$files3 = event.target.files) === null || _event$target$files3 === void 0 ? void 0 : _event$target$files3[0]);

      reader.onload = function () {
        var fileData = reader.result;
        handleGetUsers(fileData, fileName);
      };
    } else {
      void PopupsService.open(Popups.Default, {
        header: t('components.popups.incorrectFormat'),
        body: t('components.popups.error.incorrectType'),
        acceptButton: t('components.popups.ok')
      })["catch"](function () {// ToDo: error handling
      });
    }

    event.target.value = '';
  };
  /**
   * Submit users.
   *
   * @author Ihar Kazlouski
   * @return {void}
   */


  var handleSubmit = function handleSubmit() {
    PopupsService.open(Popups.Default, {
      header: t('components.popups.uploadUser'),
      body: t('components.modals.uploadAllUsers.uploadUsers'),
      acceptButton: t('components.popups.yes'),
      rejectButton: t('components.popups.cancel'),
      maxWidth: 'xs',
      width: 270
    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var error, users;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              setLoading(true);
              _context3.next = 4;
              return AdminUsersService.apiUploadUsersPost(modalData.userId, {
                body: tableData,
                params: {
                  type: modalData === null || modalData === void 0 ? void 0 : modalData.type
                }
              });

            case 4:
              ModalsService.close(Modals.AddUsersWithFile);
              _context3.next = 7;
              return modalData === null || modalData === void 0 ? void 0 : modalData.update();

            case 7:
              setLoading(false);
              _context3.next = 16;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              error = _context3.t0;
              users = error.data;
              setLoading(false);

              if (error.status === ApiResponse.Conflict) {
                if (users.find(function (user) {
                  return user.error_text.length !== 0;
                })) {
                  void PopupsService.open(Popups.Default, {
                    header: t('components.popups.errorsDetected'),
                    body: t('components.popups.error.resolvingError'),
                    acceptButton: t('components.popups.ok'),
                    width: 270
                  })["catch"](function () {// ToDo: error handling
                  });
                }

                setTableData(users);
              } else {
                void PopupsService.open(Popups.Default, {
                  header: t('components.popups.errorOccurred'),
                  body: t('components.popups.errorText'),
                  acceptButton: t('components.popups.ok'),
                  width: 270
                })["catch"](function () {// ToDo: error handling
                });
              }

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    })))["catch"](function () {// error handling
    });
  };
  /**
   * Search text field change handler.
   *
   * @author Ihar Kazlouski
   * @param {event: ChangeEvent<HTMLInputElement>} event event.
   * @return {void}
   */


  var handleChange = function handleChange(event) {
    if (event && event.target && event.target.value) {
      setValue(event.target.value);
    } else {
      setValue('');
    }
  };
  /**
   * Close modal.
   *
   * @author Ihar Kazlouski
   * @param {event: ChangeEvent<HTMLInputElement>} event event.
   * @return {void}
   */


  var closeModal = function closeModal() {
    PopupsService.open(Popups.Default, {
      header: t('components.popups.unsavedChanges'),
      body: t('components.modals.uploadAllUsers.quit'),
      acceptButton: t('components.popups.yes'),
      rejectButton: t('components.popups.cancel'),
      maxWidth: 'xs',
      width: 270
    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              ModalsService.close(Modals.AddUsersWithFile);
              _context4.next = 3;
              return modalData === null || modalData === void 0 ? void 0 : modalData.update();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })))["catch"](function () {// error handling
    });
  };

  return /*#__PURE__*/_jsxs(Modal, {
    fullWidth: true,
    maxWidth: "xxl",
    adminModal: true,
    children: [/*#__PURE__*/_jsx(Modal.Title, {
      handleClose: closeModal,
      children: /*#__PURE__*/_jsxs(Box, {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 2.5,
        paddingTop: 6,
        paddingX: 2.5,
        position: "relative",
        children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          fontWeight: "bold",
          color: "mineshaft",
          children: "Upload Users"
        }), /*#__PURE__*/_jsx(IconButton, {
          onClick: closeModal,
          size: "small",
          sx: {
            position: 'absolute',
            right: 16,
            top: 16
          },
          children: /*#__PURE__*/_jsx(Icon, {
            src: close,
            width: 24,
            height: 24,
            color: "comet"
          })
        }), /*#__PURE__*/_jsx("div", {})]
      })
    }), /*#__PURE__*/_jsx(Modal.Content, {
      children: /*#__PURE__*/_jsx(TableComponent, {
        data: (tableData === null || tableData === void 0 ? void 0 : tableData.filter(function (user) {
          var _user$first_name, _user$first_name$toLo, _user$last_name, _user$last_name$toLow, _user$phone, _user$phone$toLowerCa;

          return (user === null || user === void 0 ? void 0 : (_user$first_name = user.first_name) === null || _user$first_name === void 0 ? void 0 : (_user$first_name$toLo = _user$first_name.toLowerCase()) === null || _user$first_name$toLo === void 0 ? void 0 : _user$first_name$toLo.includes(value === null || value === void 0 ? void 0 : value.toLowerCase())) || (user === null || user === void 0 ? void 0 : (_user$last_name = user.last_name) === null || _user$last_name === void 0 ? void 0 : (_user$last_name$toLow = _user$last_name.toLowerCase()) === null || _user$last_name$toLow === void 0 ? void 0 : _user$last_name$toLow.includes(value === null || value === void 0 ? void 0 : value.toLowerCase())) || (user === null || user === void 0 ? void 0 : (_user$phone = user.phone) === null || _user$phone === void 0 ? void 0 : (_user$phone$toLowerCa = _user$phone.toLowerCase()) === null || _user$phone$toLowerCa === void 0 ? void 0 : _user$phone$toLowerCa.includes(value === null || value === void 0 ? void 0 : value.toLowerCase()));
        })) || [],
        editingMode: "row",
        enableEditing: true,
        onEditingRowSave: handleSaveRow,
        positionActionsColumn: "first",
        columns: columns,
        icons: {
          EditIcon: function EditIcon(props) {
            return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
              src: edit,
              width: 28,
              height: 28
            }, props), {}, {
              sx: {
                opacity: 'unset'
              }
            }));
          },
          SaveIcon: function SaveIcon(props) {
            return /*#__PURE__*/_jsx(Icon, _objectSpread({
              src: save,
              width: 28,
              height: 28
            }, props));
          },
          CancelIcon: function CancelIcon(props) {
            return /*#__PURE__*/_jsx(Icon, _objectSpread({
              src: closeCircle,
              width: 28,
              height: 28
            }, props));
          }
        },
        enableRowSelection: false,
        state: {
          showProgressBars: loading,
          showSkeletons: loading,
          isLoading: loading
        },
        muiTablePaperProps: {
          sx: {
            border: 'unset',
            boxShadow: 'unset'
          }
        },
        muiTableBodyCellEditTextFieldProps: {
          InputProps: {
            sx: {
              borderBottom: "1.5px solid ".concat(colors.funGreen),
              '&:before': {
                borderBottom: 'unset'
              },
              '&:after': {
                borderBottom: 'unset'
              },
              '&:hover': {
                '&:before': {
                  borderBottom: 'unset'
                },
                '&:after': {
                  borderBottom: 'unset'
                },
                '&:not(.Mui-disabled)': {
                  '&:before': {
                    borderBottom: 'unset'
                  }
                }
              }
            }
          }
        },
        muiTableBodyRowProps: function muiTableBodyRowProps(_ref9) {
          var _table$getState$editi, _row$original, _row$original$error_t;

          var row = _ref9.row,
              table = _ref9.table;
          return {
            sx: {
              verticalAlign: row.index === ((_table$getState$editi = table.getState().editingRow) === null || _table$getState$editi === void 0 ? void 0 : _table$getState$editi.index) ? 'top' : 'initial',
              backgroundColor: row !== null && row !== void 0 && (_row$original = row.original) !== null && _row$original !== void 0 && (_row$original$error_t = _row$original.error_text) !== null && _row$original$error_t !== void 0 && _row$original$error_t.length ? colors.whisper : 'none',
              '&.Mui-selected': {
                backgroundColor: colors.gin,
                '& .MuiTableCell-body': {
                  backgroundColor: colors.gin
                },
                '&:hover': {
                  backgroundColor: colors.gin
                }
              },
              '& .MuiTableCell-body': {
                '&:first-child': {
                  paddingLeft: pxToRem(40),
                  '& .MuiButtonBase-root': {
                    opacity: 'unset'
                  }
                }
              },
              '&:last-child td': {
                borderBottom: 0
              },
              '&:hover': {
                '& .MuiTableCell-body': {
                  backgroundColor: colors.gin
                }
              }
            }
          };
        },
        renderToolbarInternalActions: function renderToolbarInternalActions(_ref10) {
          var table = _ref10.table;
          return /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs(Box, {
              sx: {
                padding: "".concat(pxToRem(40), " ").concat(pxToRem(40), " ").concat(pxToRem(30))
              },
              children: [/*#__PURE__*/_jsxs(Grid, {
                container: true,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 8.75,
                children: [/*#__PURE__*/_jsx(Grid, {
                  item: true,
                  display: "flex",
                  children: /*#__PURE__*/_jsx(Typography, {
                    display: "inline",
                    variant: "h3",
                    fontWeight: "bold",
                    color: "mineShaft",
                    children: fileName
                  })
                }), /*#__PURE__*/_jsxs(Grid, {
                  item: true,
                  container: true,
                  spacing: 2,
                  width: "unset",
                  alignItems: "center",
                  children: [/*#__PURE__*/_jsx(Grid, {
                    item: true,
                    children: /*#__PURE__*/_jsxs(Button, {
                      variant: "outlined",
                      component: "label",
                      children: [/*#__PURE__*/_jsx(StyledButtonIcon, {
                        src: upload,
                        width: 24,
                        height: 24
                      }), t('components.modals.uploadAllUsers.replace'), /*#__PURE__*/_jsx("input", {
                        onChange: handleReplace,
                        accept: "text/csv",
                        type: "file",
                        hidden: true
                      })]
                    })
                  }), /*#__PURE__*/_jsx(Grid, {
                    item: true,
                    children: /*#__PURE__*/_jsx(Button, {
                      variant: "contained",
                      onClick: handleSubmit,
                      sx: {
                        padding: "".concat(pxToRem(14), " ").concat(pxToRem(28))
                      },
                      children: t('components.modals.uploadAllUsers.submit')
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx(Grid, {
                container: true,
                spacing: 2,
                alignItems: "center",
                children: /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  children: /*#__PURE__*/_jsx(TextField, {
                    size: "small",
                    placeholder: t('components.modals.uploadAllUsers.search'),
                    type: "search",
                    onChange: handleChange,
                    value: value,
                    clearable: true
                  })
                })
              })]
            })
          });
        }
      })
    })]
  });
};

export { AddUsersWithFileComponent };